
import React, { useEffect } from 'react';
import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {Routes,Route,Navigate,useNavigate } from 'react-router-dom'
import EMenu from './Components/Menu/MainMenu/EMenu';
import S3Image from './Components/S3Image'
import Caculater from './Components/Caculater';
import MasterCardForm from './Components/MasterCardForm'


function App() {

  const navigate = useNavigate();

 

  return (
    <div  className="App">
     <Routes>


          <Route path="EMenu/:branchID" element={<EMenu/>}> </Route>          
          <Route path="S3Image" element={<S3Image/>}> </Route>          
          <Route path="Caculater" element={<Caculater/>}> </Route>          
          <Route path="MasterCardForm" element={<MasterCardForm/>}> </Route>          
                     
        </Routes>
    </div>
  );
}

export default App;
